export enum EApi{
    login = "webmanage/api.login/index",
    logout = "webmanage/api.login/out",
    isLogin = "webmanage/api.user/isLogin",
    getWebOpenData = "webmanage/api.config/getWebOpenData",
    userInfo = "webmanage/api.user/getInfo",
    webConfig = "webmanage/api.config/getWebConfig",
    menuList = "webmanage/api.menu/list",

    addUploadSetting = "webmanage/api.setting/saveUploadSetting",
    getUploadSetting = "webmanage/api.setting/getUploadSetting",
    saveSettings = "webmanage/api.setting/saveSettings",
    getSettings = "webmanage/api.setting/getSettings",
}

export enum EErrCode{
    needLogin = "needLogin",
    authFail = "authFail",
}